import { xda } from '@hybird/flutter'

class CacheFileTool {

  constructor() {
    this.cacheFileMap = Object.create(null)
  }

  addCacheFile(filePath) {
    const id = (typeof crypto?.randomUUID === 'function')
      ? crypto.randomUUID()
      : Math.random().toString(36).substring(2)
    this.cacheFileMap[id] = filePath
    return id
  }

  has(id) {
    return Object.prototype.hasOwnProperty.call(this.cacheFileMap, id)
  }

  size() {
    return Object.keys(this.cacheFileMap).length
  }

  getCacheFile(id) {
    return this.cacheFileMap[id]
  }

  removeCacheFile(id) {
    const path = this.cacheFileMap[id]
    if (!path) return false
    const isBlobUrl = typeof path === 'string' && path.startsWith('blob:')
    try {
      if (isBlobUrl) {
        URL.revokeObjectURL(path)
      } else {
        xda?.deleteFilesByPaths([path])
      }
    } catch (error) {
      console.log(error, 'removeCacheFile error')
    }
    delete this.cacheFileMap[id]
    return true
  }

  removeAllCacheFiles() {
    const paths = Object.values(this.cacheFileMap).filter(Boolean)
    let removed = 0
    const blobUrls = []
    const fsPaths = []
    for (const p of paths) {
      if (typeof p === 'string' && p.startsWith('blob:')) {
        blobUrls.push(p)
      } else {
        fsPaths.push(p)
      }
    }
    try {
      if (blobUrls.length) {
        for (const url of blobUrls) {
          URL.revokeObjectURL(url)
        }
      }
      if (fsPaths.length) {
        xda?.deleteFilesByPaths(fsPaths)
      }
    } catch (error) {
      console.log(error, 'removeAllCacheFiles error')
    }
    for (const key of Object.keys(this.cacheFileMap)) {
      delete this.cacheFileMap[key]
      removed++
    }
    return removed
  }
}

export default new CacheFileTool()